/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { InvoiceType, OrderInvoice } from '@msdyn365-commerce/retail-proxy';
import { InvoicePaidStatus } from './invoice-status';

export interface IPayableInvoice {
    readonly amount?: number;
    readonly id: string;
    readonly canBePaid: boolean;
}

/**
 * Represents invoice data model.
 */
export class InvoiceModel implements IPayableInvoice {
    public id: string;

    public invoiceDate?: Date;

    public customerAccountNumber?: string;

    public customerName?: string;

    public amount?: number;

    public dueDate?: Date;

    public amountDue?: number;

    public status?: InvoicePaidStatus;

    public currencyCode?: string;

    public isSelected: boolean;

    public invoiceTypeValue: InvoiceType;

    public constructor(invoice: OrderInvoice) {
        this.id = invoice.Id || '';
        this.invoiceDate = invoice.InvoiceDate ? new Date(invoice.InvoiceDate) : undefined;
        this.customerAccountNumber = invoice.CustomerAccountNumber;
        this.customerName = invoice.CustomerName;
        this.amount = invoice.TotalAmount;
        this.dueDate = invoice.InvoiceDueDate ? new Date(invoice.InvoiceDueDate) : undefined;
        this.amountDue = invoice.AmountBalance;
        this.status = invoice.InvoicePaidStatusValue;
        this.currencyCode = invoice.CurrencyCode;
        this.invoiceTypeValue = (invoice.InvoiceTypeValue as InvoiceType) || InvoiceType.None;
        this.isSelected = false;
    }

    public get canBePaid(): boolean {
        return this.status !== InvoicePaidStatus.Paid;
    }
}
